/* const
----------------------------------------------- */
var $ = jQuery;
const wheelevent	= "onwheel" in document ? "wheel":"onmousewheel" in document ? "mousewheel":"DOMMouseScroll";
const useragent		= window.navigator.userAgent;
const is_touch		= (useragent.match(/(iPhone|iPod|iPad|Android)/i)) ? true:false;
const is_oldie		= (useragent.match(/(MSIE 6|MSIE 7|MSIE 8|MSIE 9|MSIE 10)/i)) ? true:false;
const is_ie11			= (useragent.match(/(rv:11)/i)) ? true:false;
const is_edge			= (useragent.match(/(Edge)/i)) ? true:false;

/* resize
----------------------------------------------- */
var resize = {
	ready:function() {

		resize.params = new Array();
		resize.flag = true;

		resize.body = document.body.clientHeight;
		resize.width = window.innerWidth;
		resize.height = window.innerHeight;

		window.addEventListener("resize", resize.start, false);

		resize.start();

	},
	start:function() {
		clearInterval(resize.interval);
		resize.interval = setInterval(resize.end, 50);
    
	},
	end:function() {
		clearInterval(resize.interval);
		if ((is_touch && resize.width != window.innerWidth) || !is_touch) {

			resize.width = window.innerWidth;
			resize.height = window.innerHeight;

			for (let i in resize.params) {
				resize.params[i]();
			}

		}

		resize.body = document.body.clientHeight;

	}
}

/* Navigation Menu Open
----------------------------------------------- */
var $header = $("#header");
var $gnav = $(".header__navWrap")
var $gnavBtn = $(".js-headerTrigger");
var $engNavLink = $(".english .header a");
var _scrTop = $(window).scrollTop(), _tmpScrTop = 0;

$gnavBtn.click(function(){
  var $this = $(this);

  $this.toggleClass('active');
  var isActive = $this.hasClass('active');
  if(isActive) {
    _tmpScrTop = $(window).scrollTop();
    //$("body").css('top', - _tmpScrTop).addClass('js-naviopen');
    $("body").css('top', - _tmpScrTop).addClass('js-naviopen');
    //$("#container").css('top', - _tmpScrTop);
    //no_scroll();
    
  }else{
    $("body").removeClass('js-naviopen').css('top', '');
    //return_scroll();
    $(window).scrollTop(_tmpScrTop);
    _tmpScrTop = null;
  }
  
  return false;
});
$(".header__navWrap").find("a").click(function(){
  if( $("body").hasClass("js-naviopen") )  $gnavBtn.click();
});

/* Glonavi / Scroll change
----------------------------------------------- */
const scrollTrigger = ( location.pathname==="/"||location.pathname==="/index.php" )?document.getElementById('nextAnc'):document.getElementById('hero');
const scrollHeader = document.getElementById("header");

function gnavScrollFix() {
  var scrollY = window.pageYOffset;
  if(!scrollTrigger) return;

  let triggerClientRect = scrollTrigger.getBoundingClientRect();
  let triggerY = scrollY + triggerClientRect.top;
  if(scrollY > triggerY) {
    scrollHeader.classList.add('js-fixed');
  } else{
    scrollHeader.classList.remove('js-fixed');
  }

}
window.addEventListener('scroll', gnavScrollFix);
window.addEventListener('DOMContentLoaded', gnavScrollFix);

/* PageTop / Scroll change
----------------------------------------------- */
const scrollPageTopTrigger = document.getElementById('bottom');
const scrollPagetop = document.getElementById("pagetop");

function pagetopScrollFix() {
  var scrollY = window.pageYOffset;

  if(!scrollPageTopTrigger) return;

  let triggerClientRect = scrollPageTopTrigger.getBoundingClientRect();
  let triggerY = scrollY + triggerClientRect.top;
  
  if(scrollY+document.documentElement.clientHeight > triggerY) {
    scrollPagetop.classList.add('js-nonFixed');
  } else{
    scrollPagetop.classList.remove('js-nonFixed');
  }

  let triggerClientRectHead = scrollTrigger.getBoundingClientRect();
  let triggerYHead = scrollY + triggerClientRectHead.top+scrollTrigger.clientHeight;

  if(scrollY+document.documentElement.clientHeight > triggerYHead ) {
    scrollPagetop.classList.add('js-show');
  } else{
    scrollPagetop.classList.remove('js-show');
  }


}
window.addEventListener('scroll', pagetopScrollFix);

/* Ancer Link
----------------------------------------------- */
var _ancEase = "easeInOutQuart";
function anchorFunc( _this ){
  var Hash = $(_this.hash);
  let headerHeight = ( $(window).width()>=768  )?$("#header").height():0;

  if (!Hash || Hash.length === 0) {
    return false;
  }
  var HashOffset = $(Hash).offset().top,_mgn = +40;
  $("html,body").animate({
    scrollTop: HashOffset-headerHeight
  }, 700 ,_ancEase);
  setTimeout(function(){
    $("html,body").animate({
      scrollTop: HashOffset-headerHeight
    }, 700 ,_ancEase);
  },700);
  return false;
}
$("main a[href*='#'],.btn_pageTop[href*='#'],body.english footer a[href*='#']").click(function(e){
  //e.preventDefault();
  let $this = $(this), _href = $this.attr("href");
  e.preventDefault();
  anchorFunc( this );
  return false;
});
$(".header a[href*='#']").click(function(e){
  //e.preventDefault();
  let $this = $(this), _href = $this.attr("href");
  //let _nowUrl = (location.pathname.split('#')[1])?location.pathname.split('#')[0]:location.pathname;
  //_nowUrl = (_nowUrl.split('/index.php')[1])?_nowUrl.split('/index.php')[0]:_nowUrl;
  let _nowUrl = location.pathname;
  if( _nowUrl.indexOf(_href.split("#")[0])!=-1 ){
    e.preventDefault();
    anchorFunc( this );
    return false;
  }
});
if( location.hash ){
  window.addEventListener('DOMContentLoaded', function(){
    anchorFunc( location );
  });
}



/* ready
----------------------------------------------- */
resize.ready();


